/* eslint vue/one-component-per-file:0 */

import { createTimeline } from 'animejs';
import { createApp } from 'vue';

import Filter_Animation from './animations/_filter.js';
import Listings_Animation from './animations/_listings.js';
import Scan_Animation from './animations/_scan.js';
import Split_Image_Animation from './animations/_split-image.js';
import Home_V2_Jobs_App from './home-v2-jobs-app.vue';

// Animations
(function () {
	const options = {
		threshold: 1.0,
		rootMargin: `32px`,
	};

	const callback = (entries) => {
		for (const entry of entries) {
			if (entry.isIntersecting) {
				entry.target.animation.play();
			} else {
				entry.target.animation.pause();
			}
		}
	};

	const observer = new IntersectionObserver(callback, options);

	const split_image_tl = createTimeline({
		autoplay: false,
		loop: true,
		loopDelay: 1800,
	});

	const split_image_animation_els = document.querySelectorAll(`.home-v2-section-hero .image-container`);
	for (const animation_el of split_image_animation_els) {
		const tl = new Split_Image_Animation(animation_el);
		if (!tl) {
			continue;
		}

		split_image_tl.sync(tl);
	}

	if (split_image_animation_els.length > 0) {
		const animation_el = split_image_animation_els[0];

		animation_el.animation = split_image_tl;
		observer.observe(animation_el);
	}

	const filter_animation_els = document.querySelectorAll(`.animation-filters`);
	for (const animation_el of filter_animation_els) {
		const animation = new Filter_Animation(animation_el);
		if (!animation) {
			continue;
		}

		animation_el.animation = animation;
		observer.observe(animation_el);
	}

	const listings_animation_els = document.querySelectorAll(`.animation-listings`);
	for (const animation_el of listings_animation_els) {
		const animation = new Listings_Animation(animation_el);
		if (!animation) {
			continue;
		}

		animation_el.animation = animation;
		observer.observe(animation_el);
	}

	const scan_animation_els = document.querySelectorAll(`.animation-scan`);
	for (const animation_el of scan_animation_els) {
		const animation = new Scan_Animation(animation_el);
		if (!animation) {
			continue;
		}

		animation_el.animation = animation;
		observer.observe(animation_el);
	}
})();

// Jobs App
(function () {
	const app_els = document.querySelectorAll(`.home-v2-jobs-app`);
	if (app_els.length === 0) {
		return;
	}

	for (const app_el of app_els) {
		const app = createApp(Home_V2_Jobs_App, {
			api_url: app_el.dataset.api_url,
			logo_url_template: app_el.dataset.logo_url_template,
		});

		app.mount(app_el);
	}
})();
